import { LoadingSpinner } from "@vfuk/core-loading-spinner";

import { Stack } from "../Stack";

// NB - use this component in conjunction with IntersectionObserverMarker to create 'infinite scroll'.

interface InfiniteSCrollViewProps {
  loadingMessage: string;
}
export const InfiniteSCrollView = ({
  loadingMessage,
}: InfiniteSCrollViewProps) => {
  return (
    <Stack direction="row" justifyContent="center">
      <Stack direction="column">
        <LoadingSpinner appearance="secondary" size={5} />
        <p>{loadingMessage}</p>
      </Stack>
    </Stack>
  );
};
